import { useMatchMedia } from '@xing-com/crate-hooks-use-match-media';
import { useDeviceInfo, useHost } from '@xing-com/crate-xinglet';
import { mediaSmallOrTiny } from '@xing-com/layout-tokens';

export const useScreen = () => {
  const isSmallOrTiny = useMatchMedia(mediaSmallOrTiny);
  const { isServer } = useHost();
  const { isWebview } = useDeviceInfo();

  const isSmallScreen = isServer ? isWebview : isSmallOrTiny;

  return { isSmallScreen };
};
